module.exports = __webpack_public_path__ + "img/instagram_music_disc_sticker.0ec0a33d.png";